import { webDataNotAsked } from "@lvt/web-data";
import { DateTime } from "luxon";

import { RootState } from "@/store";
import { hourInSeconds } from "@/utilities/time";
import { PresetsToImages, BucketImages } from "@/utilities/types/archive";


// Need a selector that takes the root state and retrieves preset images based of preset ids and the start and stop time
export const retrieveThumbnails = (
    presetIds: number[],
    startTime: DateTime,
    endTime: DateTime,
): ((state: RootState) => BucketImages) => {
    return (state: RootState) => {
        if (startTime > endTime) {
            return {};
        }

        const archiveState = state.archives;

        const startTimeSeconds = startTime.toSeconds();
        const startBucket = startTimeSeconds - (startTimeSeconds % hourInSeconds);
        const endTimeSeconds = endTime.toSeconds();
        const endBucket = endTimeSeconds - (endTimeSeconds % hourInSeconds);

        const presetsImages: BucketImages = {};
        let currentBucket = startBucket;

        while (currentBucket <= endBucket) {
            const imagesBucket = archiveState.images[currentBucket];
            const emptyPresetImages: PresetsToImages = {};

            presetsImages[currentBucket] = presetIds.reduce((sofar, next) => {
                if (imagesBucket && imagesBucket[next]) {
                    sofar[next] = imagesBucket[next];
                } else {
                    sofar[next] = webDataNotAsked();
                }

                return sofar;
            }, emptyPresetImages);

            // Move on to the next bucket
            currentBucket += hourInSeconds;
        }

        return presetsImages;
    };
};
